import React, { useState } from "react";

import { TextField, Button, Box, Typography, Container } from "@mui/material";
import { useFormik } from "formik";
import debounce from "lodash.debounce";

import Autocomplete from "@mui/material/Autocomplete";
import { Checkbox, FormControlLabel } from "@mui/material";

import { userDeleteSchema } from "../utils/validation";
import { axiosInstance } from "../service/axiosInstance";

import serviceEndpoints from "../services/serviceEndpoints";
import withDialog from "../commonComponents/withDialog";

const UserDetailsPopUpContent = ({ userData, deleteUser }) => {
  const [isConfirmed, setIsConfirmed] = useState(false);

  return (
    <>
      <Typography variant="h5" className="typography_heading popup_head">
        Name: <span sx={{ fontSize: "15px" }}> {userData.name || "NA"}</span>
      </Typography>

      <Typography variant="h5" className="typography_heading popup_head">
        Email: <span> {userData.email || "NA"}</span>
      </Typography>

      <Typography variant="h6" className="typography_heading popup_head">
        Mobile: <span> {userData.mobile || "NA"}</span>
      </Typography>

      <Typography variant="h6" className="typography_heading popup_head">
        Channel: <span> {userData.channel || "NA"}</span>
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={isConfirmed}
            onChange={(e) => setIsConfirmed(e.target.checked)}
          />
        }
        label="I acknowledge that I want to delete this user."
      />
      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={!isConfirmed}
        className="mt-2"
        onClick={deleteUser}
      >
        Confirm
      </Button>
    </>
  );
};

const UserDetailsDialog = withDialog(UserDetailsPopUpContent, "Delete user");

const DeleteUserComponent = ({ setShowSuccess }) => {
  const [userEmailOption, setUserEmailOptions] = useState([]);
  const [userData, setUserData] = useState({});
  const [openUserModal, setOpenUserModal] = useState(false);

  const fetchUserEmails = async (query) => {
    if (query.length < 2) return;

    try {
      const response = await axiosInstance.post(
        serviceEndpoints.fetchUserEmailList,
        {
          email: query,
        }
      );
      setUserEmailOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching managers:", error);
    }
  };

  const debouncedFetchUserEmails = debounce(fetchUserEmails, 300);

  const { handleSubmit, touched, errors, values, setFieldValue } = useFormik({
    initialValues: {
      email: null,
    },
    onSubmit: (values) => handleDelete(values),
    validationSchema: userDeleteSchema,
  });

  const handleDelete = async (values) => {
    setOpenUserModal(true);
  };

  const handleEmailValue = async (newValue) => {
    setFieldValue("email", newValue || null);
    try {
      let userDetailRes = await axiosInstance.post(
        serviceEndpoints.fetchUserDetails,
        {
          userId: newValue.id,
        }
      );
      setUserData(userDetailRes.data.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const deleteUser = async () => {
    try {
      await axiosInstance.post(serviceEndpoints.deleteUserEndpoints, {
        userId: values.email.id,
      });
      setShowSuccess(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        marginTop: 4,
        marginBottom: 2,
        paddingBottom: "80px",
      }}
    >
      <UserDetailsDialog
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        userData={userData}
        deleteUser={deleteUser}
      />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          console.log("Errors:", errors);
          handleSubmit();
        }}
      >
        <Box
          className="border-box container_bg"
          sx={{
            alignItems: "center",
            borderRadius: "30px",
            padding: 2,
            // border: "1px solid #ddd",
            flexDirection: "row",
            marginBottom: 2,
          }}
        >
          <Box sx={{ marginBottom: 2 }}>
            <Typography
              variant="h6"
              className="typography_heading form_sub_head"
            >
              Email <span className="mandatory_mark"> *</span>
            </Typography>
            <Autocomplete
              options={userEmailOption}
              getOptionLabel={(option) => option.email}
              value={values.email}
              onInputChange={(event, newInputValue) => {
                debouncedFetchUserEmails(newInputValue);
              }}
              onChange={(event, newValue) => {
                handleEmailValue(newValue);
              }}
              name="email"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search by Email"
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
              )}
            />
          </Box>
        </Box>
        <Button type="submit" variant="contained" fullWidth>
          Delete
        </Button>
      </form>
    </Container>
  );
};

export default DeleteUserComponent;
